import { render, staticRenderFns } from "./HistoriesLivePage.vue?vue&type=template&id=9ec46b0a&scoped=true&"
import script from "./HistoriesLivePage.vue?vue&type=script&lang=js&"
export * from "./HistoriesLivePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec46b0a",
  null
  
)

export default component.exports